window.CardQuestion = SiQuestion.extend({
    render: function() {
        this.$backgroundManager = $(".background-image-container");
        this.$backgroundManager.addClass("card-background"); // not a nice solution, can we accept colours in BackgroundManager?

        this.data = this.getData(this.$xml, this.language);
        this.data.language = this.language;
        var $content = $(this.getContent(this.data));
        this.$el.html($content);

        this.setupVariables();
        this.updateInteraction();
        this.setupInteraction();

        this.complete();
    },

    setupVariables: function() {
        this.greyCircle = true;
        this.title = this.data.blockTitle;
        this.question = this.data.question.question;

        this.$chartWrapper = this.$el.find(".chart-wrapper");
        this.$chartWheel = this.$el.find(".chart-options");
        this.$buttonHolder = this.$el.find(".button-holder");
        this.$confirmButton = this.$el.find(".confirm-button");
        this.$pinButton = this.$el.find(".pin-button");
        this.$flipButton = this.$el.find(".flip-button");
        this.$starButton = this.$el.find(".star");
        this.$badgeTitle = this.$el.find(".badge-title");
    },

    updateInteraction: function() {
        this.pageID = this.blockData.pageID();
        this.skillManager = this.app.getComponent("SkillsManager");

        var skill = this.skillManager.getSkill(this.pageID);
        if (skill !== undefined) {
            this.notes = skill.getNotes();
            this.rating = skill.getRating();
            this.isPinned = skill.isPinned();
        } else {
            this.notes = "";
            this.rating = -1;
            this.isPinned = false;
        }
    },

    setupInteraction: function() {
        this.initializeListbox();
        this.setupButtonListeners();

        // var $elements = this.$el.find('.title, .statement, .question-text, .instruction, .star, .button-holder');
        // this.animateIn($elements);
		
        var $card = this.$el.find('.question-screen');
		var $stars = this.$el.find('.star, .chart-options');

		// Bring card in
        TweenMax.fromTo( $card, 0.7, {
			y: 470,
        }, {
            y: 0,
            ease: Power4.easeOut
		});
		
		// Bring stars in
		TweenMax.staggerFromTo($stars, 1, {
			rotation: 10,
			opacity: 0,
			y: 50,
		}, {
			y: 0,
			opacity: 1,
			rotation: 0,
			ease: Power4.easeOut
		}, 0.1);
    },

    setupButtonListeners: function() {
        this.confirmButton = new Button({
            el: this.$confirmButton,
            isDisabled: (this.rating === -1) ? true : false
        });
        this.listenTo(this.confirmButton, "onClick", this.handleConfirm);

        this.pinButton = new Button({
            el: this.$pinButton
        });
        if (this.isPinned) {
            this.$pinButton.html(this.data.unpinLabel);
        } else {
            this.$pinButton.html(this.data.pinLabel);
        }
        this.listenTo(this.pinButton, "onClick", this.handlePin);

        this.flipButton = new Button({
            el: this.$flipButton
        });
        this.listenTo(this.flipButton, "onClick", this.handleFlip);

        _.each(this.$starButton, function(button) {
            var starButton = new Button({
                el: $(button),
                buttonClass: ''
            });
            this.listenTo(starButton, "onClick", this.handleStarClick);
        }, this);

        if (this.rating != -1) {
            var $starButton = this.$starButton.eq(this.rating);
            this.handleStarClick({
                target: $starButton
            });
        }
    },

    handleFlip: function() {
        var self = this;

        var content = Handlebars.templates["question/carddialog"]({
            instructions: LanguageManager.getString('pin_popup')
        });

        this.textArea = new TextArea({
            id: "notes",
            value: this.notes,
            maxLength: SkillsManager.MAX_NOTES_LENGTH,
            useCharCounter: true,
            rows: 4
        });

        if (this.bootbox === undefined) {
            this.bootbox = new AccessibleBootbox({
                title: this.data.blockTitle,
                message: content,
                animate: true,
                className: "pin-popup",
                buttons: {
                    ok: {
                        label: this.data.pinLabel,
                        className: "btn-primary",
                        callback: function() {
                            if (self.bootbox !== undefined) {
                                self.handlePinAdd();
                                self.bootbox.destroy();
                            }
                            self.bootbox = undefined;
                            // self.$notes.off();
                            self.textArea.destroy();
                        }
                    },
                    cancel: {
                        label: LanguageManager.getString('cancel'),
                        callback: function() {
                            if (self.bootbox !== undefined) {
                                self.bootbox.destroy();
                            }
                            self.bootbox = undefined;
                            // self.$notes.off();
                            self.textArea.destroy();
                        }
                    }
                }
            });
            this.bootbox.popIn();

            var $content = $(".bootbox-body");
            $content.append(this.textArea.$el);
        }
    },

    handlePin: function() {
        if (!this.isPinned) {
            this.isPinned = true;
            this.pinButton.$el.html(this.data.unpinLabel);
        } else {
            this.isPinned = false;
            this.pinButton.$el.html(this.data.pinLabel);
        }
        this.updateSkill();
    },

    handleConfirm: function() {
        if (this.confirmButton.isDisabled()) return;
        this.rating = this.dataValue / 2;

        this.updateSkill();

        this.trigger("onRatingSelected", {
            target: this,
            rating: this.rating,
            skill: this.skillManager.getSkill(this.pageID)
        });

        this.app.router.next();
    },

    handlePinAdd: function() {
        this.pinButton.$el.html(this.data.unpinLabel);
        this.notes = this.textArea.getValue();
        this.isPinned = true;
        this.updateSkill();
    },

    updateSkill: function() {
        this.skillManager.addSkill({
            pageId: this.pageID,
            skillId: this.data.question.id,
            category: this.data.category,
            rating: this.rating,
            title: this.title,
            notes: this.notes,
            isPinned: this.isPinned
        });
    },

    handleStarClick: function(e) {
        this.hideGreyCircle();
        this.dataValue = parseInt($(e.target).attr("data-value"));
        $(e.target).removeClass('selected');
        $(e.target).addClass('selected');
        $(e.target).parent().prevAll().find(".star").addClass('selected');
        $(e.target).parent().nextAll().find(".star").removeClass('selected');
        this.rotateProgressWheel(this.dataValue);
    },

    hideGreyCircle: function() {
        var self = this;
        var $greyCircle = this.$el.find(".grey-circle");
        var $colorCircle = this.$el.find(".color-circle");
        if (this.greyCircle) {
            TweenMax.fromTo($greyCircle, 0.3, {
                opacity: 1
            }, {
                opacity: 0,
                ease: Power4.easeIn,
                onComplete: function() {
                    $greyCircle.hide();
                    self.greyCircle = false;
                }
            });

            TweenMax.fromTo($colorCircle, 0.3, {
                opacity: 0.3
            }, {
                opacity: 1,
                ease: Power4.easeOut
            });
            this.confirmButton.toggleDisabled(false);
        }
    },

    rotateProgressWheel: function(dataValue) {
        var rotationAngle = 0;
        rotationAngle = dataValue * 45;
        TweenMax.to(this.$chartWheel, 1.5, {
            rotation: rotationAngle,
            opacity: 1,
            ease: Back.easeInOut.config(0.5),
            force3D: true
        });
    },

    getData: function($xml, language) {
        var data = {};
        data = SiQuestion.prototype.getData.call(this, $xml, "en");
        return data;
    },

    getOptions: function($xml, language) {
        var options = [];
        var counter = 0;
        var $options = $xml.find("options").find("index");
        _.each($options, function(option, i) {
            var $option = $(option);
            var item = {
                id: i,
                title: $option.find("en").find("label").text(),
                isCorrect: $option.find("correct").text() === "true",
                score: parseInt($option.attr("score")) | 0,
                dataValue: i + counter,
                optionFeedback: {
                    dataValue: i + counter,
                    title: $option.find("en").find("feedbackTitle").text(),
                    content: $option.find("en").find("feedback").text(),
                },
                selected: false
            };
            // We need to use this for calculate dataValue
            counter++;
            // highlight correct answer if unlocked
            if (!this.app.isLocked && item.isCorrect) {
                item.title = "* " + item.title;
            }
            options.push(item);
        }, this);

        return options;
    },

    getQuestion: function($xml, language) {
        var question = {
            id: $xml.find("mainText").attr("id").trim(),
            question: $xml.find("question").find(language).find("text").text().trim(),
            statement: $xml.find("statement").find(language).find("text").text(),
            imagePath: URLHelper.getCleanImageUrl($xml.find("image").text()),
            category: $xml.find("mainText").attr("category")
        };

        return question;
    },

    getLables: function(data) {
        SiQuestion.prototype.getLables.call(this, data);
        data.pinLabel = LanguageManager.getString("pin");
        data.unpinLabel = LanguageManager.getString("unpin");
        data.flipLabel = LanguageManager.getString("flip");
    },

    getGlobalSetting: function(data, $xml) {
        data.blockTitle = $xml.find("mainText").find("text").text();
        data.category = $xml.find("mainText").attr("category");
        data.categoryLabel = LanguageManager.getString(data.category);
        data.categoryClass = data.category.toLowerCase();
        data.instruction = LanguageManager.getString("stars_instruction");
        Logger.info(this.blockData.pageID(), ":", data.category);
        SiQuestion.prototype.getGlobalSetting.call(this, data, $xml);
    },

    getContent: function(data) {
        return Handlebars.templates["question/cardquestion"](data);
    },

    destroy: function() {
        if (this.bootbox) {
            this.bootbox.popOut();
            this.bootbox.destroy();
            this.bootbox = undefined;
        }

        if (this.$backgroundManager) this.$backgroundManager.removeClass("card-background");

        this.stopListening(this.confirmButton, "onClick");
        this.stopListening(this.pinButton, "onClick");
        this.stopListening(this.flipButton, "onClick");
        this.stopListening(this.starButton, "onClick");
        this.$starButton.unbind("mouseenter");
        this.$starButton.unbind("mouseleave");

        SiQuestion.prototype.destroy.call(this);
    }
});
